import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import AddGroupInput from '../UsersScreen/_components/AddGroupInput'

const EMPTY_GROUP_SETTING = {
    group_id: '',
    esse3_test_id: '',
    esse3_aa_id: '',
    subjects: [],
    video_completion_group_id: '',
    retry_exam_group_id: ''
}

export default function OfaGroupSettingModal({ show, isNew, initialData, subjects, onClose, onConfirm }){
    const t = useSelector(selectTranslations)

    const [draft, setDraft] = useState(EMPTY_GROUP_SETTING)
    const [selectedSubjectId, setSelectedSubjectId] = useState('')

    useEffect(()=>{
        if(show){
            setDraft(initialData ? { ...EMPTY_GROUP_SETTING, ...initialData, subjects: initialData.subjects || [] } : EMPTY_GROUP_SETTING)
            setSelectedSubjectId('')
        }
    },[show, initialData])

    const updateField = (key, value) => {
        setDraft(prev => ({ ...prev, [key]: value }))
    }

    const addSubject = () => {
        if(!selectedSubjectId) return
        const subject = subjects?.find(s => `${s.subject_id}` === `${selectedSubjectId}`)
        if(!subject) return
        if(draft.subjects?.some(s => `${s.subject_id}` === `${subject.subject_id}`)) return
        setDraft(prev => ({
            ...prev,
            subjects: [ ...(prev.subjects || []), { subject_id: subject.subject_id, subject_name: subject.subject_name } ]
        }))
        setSelectedSubjectId('')
    }

    const removeSubject = (subjectIndex) => {
        setDraft(prev => {
            const subs = [...(prev.subjects || [])]
            subs.splice(subjectIndex, 1)
            return { ...prev, subjects: subs }
        })
    }

    const handleConfirm = () => {
        onConfirm(draft)
    }

    return (
        <Modal show={show} onHide={onClose} keyboard={false} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{isNew ? 'Nuova configurazione gruppo' : 'Modifica configurazione gruppo'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3" controlId="modal_group_id">
                    <Form.Label>Group ID</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control type="text" value={draft.group_id || ''} onChange={(e)=>updateField('group_id', e.target.value)} />
                        <div className="ms-2">
                            <AddGroupInput label={'Seleziona gruppo'} onAddGroup={(grp)=>updateField('group_id', grp?.group_id)} />
                        </div>
                    </div>
                </Form.Group>

                <div className="d-flex flex-wrap">
                    <Form.Group className="me-3 mb-3" controlId="modal_esse3_test_id">
                        <Form.Label>Esse3 Test ID</Form.Label>
                        <Form.Control type="text" value={draft.esse3_test_id || ''} onChange={(e)=>updateField('esse3_test_id', e.target.value)} />
                    </Form.Group>
                    <Form.Group className="me-3 mb-3" controlId="modal_esse3_aa_id">
                        <Form.Label>Esse3 AA ID</Form.Label>
                        <Form.Control type="text" value={draft.esse3_aa_id || ''} onChange={(e)=>updateField('esse3_aa_id', e.target.value)} />
                    </Form.Group>
                </div>

                <Form.Group className="mb-3" controlId="modal_video_group_id">
                    <Form.Label>Video completion group ID</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control type="text" value={draft.video_completion_group_id || ''} onChange={(e)=>updateField('video_completion_group_id', e.target.value)} />
                        <div className="ms-2">
                            <AddGroupInput label={'Seleziona gruppo'} onAddGroup={(grp)=>updateField('video_completion_group_id', grp?.group_id)} />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="mb-3" controlId="modal_retry_group_id">
                    <Form.Label>Retry exam group ID</Form.Label>
                    <div className="d-flex align-items-center">
                        <Form.Control type="text" value={draft.retry_exam_group_id || ''} onChange={(e)=>updateField('retry_exam_group_id', e.target.value)} />
                        <div className="ms-2">
                            <AddGroupInput label={'Seleziona gruppo'} onAddGroup={(grp)=>updateField('retry_exam_group_id', grp?.group_id)} />
                        </div>
                    </div>
                </Form.Group>

                <hr />

                <div className="d-flex justify-content-between align-items-end mb-2">
                    <h6 className="mb-0">Materie</h6>
                    <div className="d-flex align-items-end">
                        <Form.Group className="me-2" controlId="modal_select_subject">
                            <Form.Label>Seleziona materia</Form.Label>
                            <Form.Select value={selectedSubjectId} onChange={(e)=>setSelectedSubjectId(e.target.value)}>
                                <option value="">Scegli...</option>
                                {subjects?.map(s => (
                                    <option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <button type="button" onClick={addSubject} disabled={!selectedSubjectId}>{'Aggiungi'}</button>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>ID</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {draft.subjects?.length ? draft.subjects.map((s, sIdx)=>(
                                <tr key={sIdx}>
                                    <td>{s.subject_name}</td>
                                    <td><small className="text-muted">{s.subject_id}</small></td>
                                    <td>
                                        <button type="button" onClick={()=>removeSubject(sIdx)}>{t?.actions?.delete || 'Elimina'}</button>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={3} className="text-center text-muted">Nessuna materia</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" onClick={onClose}>{t?.modals?.abort || 'Annulla'}</button>
                <button type="button" onClick={handleConfirm}>{t?.buttons?.edit_save || 'Conferma'}</button>
            </Modal.Footer>
        </Modal>
    )
}
